<template>
  <v-layout row wrap>
    <v-flex xs12 style="position:relative">
      <v-card>
        <v-toolbar class="firstPan">
          <template v-slot:extension>
            <v-tabs
              v-model="firstPanTabs"
              fixed-tabs
            >
              <v-tabs-slider></v-tabs-slider>
              <v-tab
                href="#firstPan1&2"
                class="primary--text"
              >
                Raw Docs({{packages.length}})
              </v-tab>

              <v-tab
                href="#firstPan3"
                class="primary--text"
              >
                Approved({{approvedPackages.length}})
              </v-tab>

              <!--
              <v-tab
                href="#firstPan4"
                class="primary--text"
              >
                Rejected({{rejectedPackages.length}})
              </v-tab>

              <v-tab
                href="#firstPan5"
                class="primary--text"
              >
                Data Entry Docs({{dataEntryPackages.length}})
              </v-tab>

              <v-tab
                href="#firstPan6"
                class="primary--text"
              >
                Client Docs({{clientDocPackages.length}})
              </v-tab> -->
            </v-tabs>
          </template>
        </v-toolbar>

        <v-progress-linear
          v-if="loading"
          indeterminate
        ></v-progress-linear>
        <v-tabs-items v-model="firstPanTabs">
          <v-tab-item
            value="firstPan1"
          >
            <v-simple-table height=300 dense fixed-header>
              <template v-slot:default>
                <thead>
                  <tr>
                    <th class="text-left" width=15%>Sl No.</th>
                    <th class="text-left" width=40%>Dock Name</th>
                    <th class="text-left" width=10%>Notes</th>
                    <th class="text-left" width=10%>File</th>
                    <th class="text-left" width=25%>Category</th>
                  </tr>
                </thead>
                <draggable v-model="unSortedPackages" tag="tbody">
                  <tr v-for="(item, index) in unSortedPackages" :key="item.id">
                      <td>
                        <v-icon>reorder</v-icon> {{index+1}}
                        <!-- <v-checkbox
                          v-model="unSortedChecks[index]"
                          :label="`${index+1}`"
                        ></v-checkbox>
                      </td> -->
                      <td><a style="color: inherit;" :href="item.package.file" target="_blank">{{ item.package.name.substring(0,40) }}</a></td>
                      <td><v-icon>speaker_notes</v-icon></td>
                      <td>
                        <v-tooltip bottom>
                          <template v-slot:activator="{ on }">
                            <v-icon v-on="on" @click="loadPDF(item)">picture_as_pdf</v-icon>
                          </template>
                          <span>{{ item.package.file }}</span>
                        </v-tooltip>
                        <v-tooltip bottom>
                          <template v-slot:activator="{ on }">
                            <v-icon v-on="on" @click="deletePackage(item, index)">delete</v-icon>
                          </template>
                          <span>Delete this package?</span>
                        </v-tooltip>
                      </td>
                      <td>
                        <v-combobox
                          v-model="item.package.category"
                          :items="categories"
                          item-text="name"
                          label="Select Category"
                          chips
                        >
                        <template v-slot:selection="data">
                            <v-chip
                              :key="JSON.stringify(data.item)"
                              v-bind="data.attrs"
                              :input-value="data.selected"
                              :disabled="data.disabled"
                            >
                            <v-avatar
                              class="accent white--text"
                              left
                              v-text="data.item.name.slice(0, 1).toUpperCase()"
                            ></v-avatar>
                              {{ data.item.name }}
                            </v-chip>
                        </template>
                        </v-combobox>
                      </td>
                  </tr>
                </draggable>
              </template>
            </v-simple-table>
            <v-flex xs3 offset-xs9>
              <v-btn color="primary" dark @click="saveUnSortedPackages" :loading="snloading" :disabled="disablePackageSection">Save & Next</v-btn>
            </v-flex>
          </v-tab-item>
          <v-tab-item
            value="firstPan1&2"
          >
            <v-simple-table height=300>
              <template v-slot:default>
                <thead>
                  <tr>
                    <th class="text-left" width=15% style="padding:0px 0px 0px 15px"><v-checkbox class="rawckall" @change="toggledocs" v-model="selectall"></v-checkbox> <div style="margin-top:-1em;display:inline-flex">Sl No.</div></th>
                    <th class="text-left" width=40%>Dock Name</th>
                    <!-- <th class="text-left" width=10%>Notes</th> -->
                    <th class="text-left" width=10%>File</th>
                    <th class="text-left" width=25%>Category</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(item, index) in packages" :key="item.id">
                      <td>
                        <v-checkbox
                          v-model="packageChecks[index]"
                          :label="`${index+1}`"
                          class="rawdocsitems"
                        ></v-checkbox>
                      </td>
                      <td><a style="color: inherit;" :href="item.package.file" target="_blank">{{ item.package.name.substring(0,40) }}</a></td>
                      <!-- <td><v-icon>speaker_notes</v-icon></td> -->
                      <td>
                        <v-tooltip bottom>
                          <template v-slot:activator="{ on }">
                            <v-icon v-on="on" @click="loadPDF(item)">picture_as_pdf</v-icon>
                          </template>
                          <span>{{ item.package.file }}</span>
                        </v-tooltip>
                        <!-- <v-tooltip bottom>
                          <template v-slot:activator="{ on }">
                            <v-icon v-on="on" @click="deletePackage(item, index)">delete</v-icon>
                          </template>
                          <span>Delete this package?</span>
                        </v-tooltip> -->
                      </td>
                      <td>
                        <v-combobox
                          v-model="item.package.category"
                          :items="categories"
                          item-text="name"
                          label="Select Category"
                          chips
                        >
                        <template v-slot:selection="data">
                            <v-chip
                              :key="JSON.stringify(data.item)"
                              v-bind="data.attrs"
                              :input-value="data.selected"
                              :disabled="data.disabled"
                            >
                            <v-avatar
                              class="accent white--text"
                              left
                              v-text="data.item.name.slice(0, 1).toUpperCase()"
                            ></v-avatar>
                              {{ data.item.name }}
                            </v-chip>
                        </template>
                        </v-combobox>
                      </td>
                  </tr>
                </tbody>
              </template>
            </v-simple-table>
            <v-flex xs5 offset-xs7 align-end class="package-save-btn-div">
              <v-btn :title="tootTipText" v-bind="attrs" v-on="on" color="primary" style="margin: 0.1rem;" dark @click="saveSortedPackages" :loading="ssploading" :disabled="disablePackageSection" :class="disableClass">Save</v-btn>
              <v-btn :title="tootTipText" v-bind="attrs" v-on="on" color="primary" style="margin: 0.1rem;" dark @click="approveSortedPackages" :loading="asploading" :disabled="disablePackageSection" :class="disableClass">Approve</v-btn>
            </v-flex>
          </v-tab-item>
          <v-tab-item
            value="firstPan3"
          >
            <v-simple-table height=300>
              <template v-slot:default>
                <thead>
                  <tr>
                    <th class="text-left" width=5%></th>
                    <th class="text-left" width=10%>Sl No.</th>
                    <th class="text-left" width=40%>Dock Name</th>
                    <th class="text-left" width=10%>File</th>
                    <th class="text-left" width=25%>Category</th>
                  </tr>
                </thead>
                <draggable v-model="approvedPackages" tag="tbody">
                  <tr v-for="(item, index) in approvedPackages" :key="item.id">
                      <td>
                        <v-icon>reorder</v-icon>
                      </td>
                      <td>
                        <v-checkbox
                          v-model="approvedChecks[index]"
                          :label="`${index+1}`"
                        >
                          <v-icon>reorder</v-icon> {{index+1}}
                        </v-checkbox>
                      </td>
                      <td><a style="color: inherit;" :href="item.package.file" target="_blank">{{ item.package.name.substring(0,40) }}</a></td>
                      <td>
                        <v-tooltip bottom>
                          <template v-slot:activator="{ on }">
                            <v-icon v-on="on" @click="loadPDF(item)">picture_as_pdf</v-icon>
                          </template>
                          <span>{{ item.package.file }}</span>
                        </v-tooltip>
                        <v-tooltip bottom>
                          <template v-slot:activator="{ on }">
                            <v-icon v-on="on" @click="movePackageToFunnel(item, index)">delete</v-icon>
                          </template>
                          <span>Delete this package?</span>
                        </v-tooltip>
                      </td>
                      <td>
                        <v-combobox
                          v-model="item.package.category"
                          :items="categories"
                          item-text="name"
                          label="Select Category"
                          chips
                        >
                        <template v-slot:selection="data">
                            <v-chip
                              :key="JSON.stringify(data.item)"
                              v-bind="data.attrs"
                              :input-value="data.selected"
                              :disabled="data.disabled"
                            >
                            <v-avatar
                              class="accent white--text"
                              left
                              v-text="data.item.name.slice(0, 1).toUpperCase()"
                            ></v-avatar>
                              {{ data.item.name }}
                            </v-chip>
                        </template>
                        </v-combobox>
                      </td>
                  </tr>
                </draggable>
              </template>
            </v-simple-table>
            <v-flex xs4 offset-xs8 align-end class="package-save-btn-div" style="margin-left:20em;max-width:60%;text-align:right">
              <v-btn color="primary" style="margin: 0.1rem;" dark @click="saveApprovedPackages" :loading="saploading" :disabled="disablePackageSection">Apply Sorting</v-btn>
              <!--
              <v-btn color="primary" style="margin: 0.1rem;" dark @click="rejectApprovedPackages" :loading="raploading" :disabled="disablePackageSection">Reject</v-btn>
              -->
            </v-flex>
          </v-tab-item>
          <!--
          <v-tab-item
            value="firstPan4"
          >
            <v-simple-table height=300>
              <template v-slot:default>
                <thead>
                  <tr>
                    <th class="text-left" width=15%>Sl No.</th>
                    <th class="text-left" width=40%>Dock Name</th>
                    <th class="text-left" width=10%>Notes</th>
                    <th class="text-left" width=10%>File</th>
                    <th class="text-left" width=25%>Category</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(item, index) in rejectedPackages" :key="item.id">
                      <td>
                        <v-checkbox
                          v-model="rejectedChecks[index]"
                          :label="`${index+1}`"
                        ></v-checkbox>
                      </td>
                      <td>{{ item.package.name }}</td>
                      <td><v-icon>speaker_notes</v-icon></td>
                      <td>
                        <v-tooltip bottom>
                          <template v-slot:activator="{ on }">
                            <v-icon v-on="on" @click="loadPDF(item)">picture_as_pdf</v-icon>
                          </template>
                          <span>{{ item.package.file }}</span>
                        </v-tooltip>
                        <v-tooltip bottom>
                          <template v-slot:activator="{ on }">
                            <v-icon v-on="on" @click="movePackageToFunnel(item, index)" >delete</v-icon>
                          </template>
                          <span>Delete this package?</span>
                        </v-tooltip>
                      </td>
                      <td>
                        <v-combobox
                          v-model="item.package.category"
                          :items="categories"
                          item-text="name"
                          label="Select Category"
                          chips
                        >
                        <template v-slot:selection="data">
                            <v-chip
                              :key="JSON.stringify(data.item)"
                              v-bind="data.attrs"
                              :input-value="data.selected"
                              :disabled="data.disabled"
                            >
                            <v-avatar
                              class="accent white--text"
                              left
                              v-text="data.item.name.slice(0, 1).toUpperCase()"
                            ></v-avatar>
                              {{ data.item.name }}
                            </v-chip>
                        </template>
                        </v-combobox>
                      </td>
                  </tr>
                </tbody>
              </template>
            </v-simple-table>
            <v-flex xs5 offset-xs7 align-end class="package-save-btn-div">
              <v-btn color="primary" style="margin: 0.1rem;" dark @click="saveRejectedPackages" :loading="srploading" :disabled="disablePackageSection">Save</v-btn>
              <v-btn color="primary" style="margin: 0.1rem;" dark @click="approveRejectedPackages" :loading="arploading" :disabled="disablePackageSection">Approve</v-btn>
            </v-flex>
          </v-tab-item>
          <v-tab-item
            value="firstPan5"
          >
            <v-simple-table height=300>
              <template v-slot:default>
                <thead>
                  <tr>
                    <th class="text-left" width=20>Sl No.</th>
                    <th class="text-left" width=20>Dock Name</th>
                    <th class="text-left" width=80>File</th>
                    <th class="text-left" width=80>Action</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(item, index) in dataEntryPackages" :key="item.id">
                      <td>{{ index+1 }}</td>
                      <td>{{ item.package.name }}</td>
                      <td>
                        <v-tooltip bottom>
                          <template v-slot:activator="{ on }">
                            <v-icon v-on="on" @click="loadPDF(item)">picture_as_pdf</v-icon>
                          </template>
                          <span>{{ item.package.file }}</span>
                        </v-tooltip>
                      </td>
                      <td>
                        <v-tooltip bottom>
                          <template v-slot:activator="{ on }">
                            <v-icon v-on="on" @click="deletePackage(item, index)" :disabled="disablePackageSection">delete</v-icon>
                          </template>
                          <span>Delete this package?</span>
                        </v-tooltip>
                      </td>
                  </tr>
                </tbody>
              </template>
            </v-simple-table>
            <v-layout>
              <v-flex xs10>
                <v-file-input
                  v-model="dataEntryFiles"
                  placeholder="Upload your Data Entry Docs"
                  label="File input"
                  prepend-icon="mdi-paperclip"
                  multiple
                  :disabled="uploading"
                >
                  <template v-slot:selection="{ text }">
                    <v-chip
                      small
                      label
                      color="rtsPrimary"
                    >
                      {{ text }}
                    </v-chip>
                  </template>
                </v-file-input>
              </v-flex>
              <v-flex xs2>
                <v-btn color="primary" dark @click="uploadDocument('dataEntry')" :loading="uploading" :disabled="disablePackageSection">Upload</v-btn>
              </v-flex>
            </v-layout>
          </v-tab-item>
          <v-tab-item
            value="firstPan6"
          >
            <v-simple-table height=300>
              <template v-slot:default>
                <thead>
                  <tr>
                    <th class="text-left" width=20>Sl No.</th>
                    <th class="text-left" width=20>Dock Name</th>
                    <th class="text-left" width=80>File</th>
                    <th class="text-left" width=80>Action</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(item, index) in clientDocPackages" :key="item.id">
                      <td>{{ index+1 }}</td>
                      <td>{{ item.package.name }}</td>
                      <td>
                        <v-tooltip bottom>
                          <template v-slot:activator="{ on }">
                            <v-icon v-on="on" @click="loadPDF(item)">picture_as_pdf</v-icon>
                          </template>
                          <span>{{ item.package.file }}</span>
                        </v-tooltip>
                      </td>
                      <td>
                        <v-tooltip bottom>
                          <template v-slot:activator="{ on }">
                            <v-icon v-on="on" @click="deletePackage(item, index)" :disabled="disablePackageSection">delete</v-icon>
                          </template>
                          <span>Delete this package?</span>
                        </v-tooltip>
                      </td>
                  </tr>
                </tbody>
              </template>
            </v-simple-table>
            <v-layout>
              <v-flex xs10>
                <v-file-input
                  v-model="clientDocFiles"
                  placeholder="Upload your Client Docs"
                  label="File input"
                  prepend-icon="mdi-paperclip"
                  multiple
                  :disabled="uploading"
                >
                  <template v-slot:selection="{ text }">
                    <v-chip
                      small
                      label
                      color="rtsPrimary"
                    >
                      {{ text }}
                    </v-chip>
                  </template>
                </v-file-input>
              </v-flex>
              <v-flex xs2>
                <v-btn color="primary" dark @click="uploadDocument('clientDoc')" :loading="uploading" :disabled="disablePackageSection">Upload</v-btn>
              </v-flex>
            </v-layout>
          </v-tab-item>
          -->
        </v-tabs-items>
      </v-card>
    </v-flex>
    <v-flex xs12 text-center v-if="disablePackageSection" >
      <span  class="red--text">Package can only be edited in In House or Examine stage.</span>
    </v-flex>
    <v-flex xs10>
      <v-file-input
        v-model="files"
        placeholder="Upload your documents"
        label="File input"
        prepend-icon="mdi-paperclip"
        multiple
        :disabled="uploading"
      >
        <template v-slot:selection="{ text }">
          <v-chip
            small
            label
            color="rtsPrimary"
          >
            {{ text }}
          </v-chip>
        </template>
      </v-file-input>
    </v-flex>
    <v-flex xs2>
      <v-btn color="primary"  dark @click="uploadDocument('sorted')" :loading="uploading" :disabled="disablePackageSection"> Uploads</v-btn>
    </v-flex>
  </v-layout>
</template>

<script>
// @ is an alias to /src
import draggable from 'vuedraggable'
import Vue from 'vue'
import {
  GETORDERPACKAGELISTBYORDERID, GETPACKAGECATEGORIESLIST,
  DELETEPACKAGE, UPLOADPACKAGE, ADDORDERPACKAGE, PATCHPACKAGE, PATCHORDERPACKAGE, POSTNOTE, SORTALLORDERPACKAGES
} from '@/store/actions.type'
Vue.filter('formatAddress', function (value) {
  if (value) {
    return value.street + ', ' + value.county.name + ', ' + value.zip_code
  }
})

Vue.filter('formatDate', function (value) {
  if (value) {
    return new Date(value).toLocaleString(
      'en-US', { timeZone: 'America/Los_Angeles', hourCycle: 'h23' }
    ).replace(',', '')
  }
})

export default {
  name: 'orderPackageManager',
  components: {
    draggable
  },
  data () {
    return {
      dragging: true,
      loading: false,
      uploading: false,
      firstPanTabs: null,
      packages: null,
      packageChecks: [],
      unSortedPackages: [],
      unSortedChecks: [],
      sortedPackages: [],
      sortedChecks: [],
      approvedPackages: [],
      approvedChecks: [],
      rejectedPackages: [],
      rejectedChecks: [],
      dataEntryPackages: [],
      clientDocPackages: [],
      categories: [],
      dataEntryFiles: undefined,
      clientDocFiles: undefined,
      files: undefined,
      disablePackageSection: false,
      disableClass: '',
      selectall: false
    }
  },
  props: {
    order: null
  },
  mounted () {
    console.log(this.order.status.slug)
    if (this.order.status.slug !== 'in-house' && this.order.status.slug !== 'examine' && this.order.status.slug !== 'waiting-docs') {
      this.disablePackageSection = true
      this.disableClass = 'disableClass'
    }
    this.getOrderPackage()
    this.$store
      .dispatch(GETPACKAGECATEGORIESLIST)
      .then(response => {
        console.log(response)
        this.categories = response.results
      })
  },
  methods: {
    getOrderPackage () {
      let payload = {
        order__id: this.order.id
      }
      this.$store
        .dispatch(GETORDERPACKAGELISTBYORDERID, payload)
        .then(response => {
          console.log(response)
          this.packages = response.results
          for (let i = 0; i < response.results.length; i++) {
            this.packageChecks.push(false)
            if (response.results[i].status === 'UnSorted') {
              this.unSortedPackages.push(response.results[i])
              this.unSortedChecks.push(false)
            }
            if (response.results[i].status === 'Sorted') {
              this.sortedPackages.push(response.results[i])
              this.sortedChecks.push(false)
            }
            if (response.results[i].status === 'Approved') {
              if (this.approvedPackages.length === 0) {
                this.approvedPackages.push(response.results[i])
              } else {
                if (response.results[i].ordering >= this.approvedPackages[this.approvedPackages.length - 1].ordering) {
                  this.approvedPackages.push(response.results[i])
                } else {
                  this.approvedPackages.unshift(response.results[i])
                }
              }
              this.approvedChecks.push(false)
            }
            if (response.results[i].status === 'Rejected') {
              this.rejectedPackages.push(response.results[i])
              this.rejectedChecks.push(false)
            }
            if (response.results[i].status === 'DataEntry') {
              this.dataEntryPackages.push(response.results[i])
            }
            if (response.results[i].status === 'ClientDoc') {
              this.clientDocPackages.push(response.results[i])
            }
          }
          console.log(this.approvedPackages)
        })
    },
    movePackageToFunnel (orderPackage, index) {
      let orderPackagePayload = {
        id: orderPackage.id,
        status: 'RawDocs'
      }
      this.$store.dispatch(PATCHORDERPACKAGE, orderPackagePayload).then(resp => {
        if (orderPackage.status === 'Approved') {
          this.approvedPackages.splice(index, 1)
        }
        if (orderPackage.status === 'Rejected') {
          this.rejectedPackages.splice(index, 1)
        }
        this.addOrderNote(orderPackage.package.name + ' was deleted')
      }).catch(({ response }) => {
        console.log(response)
      })
    },
    deletePackage (orderPackage, index) {
      this.$store
        .dispatch(DELETEPACKAGE, orderPackage)
        .then(response => {
          console.log(response)
          this.categories = response.results
          if (orderPackage.status === 'UnSorted') {
            this.unSortedPackages.splice(index, 1)
          }
          if (orderPackage.status === 'Sorted') {
            this.sortedPackages.splice(index, 1)
          }
          if (orderPackage.status === 'Approved') {
            this.approvedPackages.splice(index, 1)
          }
          if (orderPackage.status === 'Rejected') {
            this.rejectedPackages.splice(index, 1)
          }
          if (orderPackage.status === 'DataEntry') {
            this.dataEntryPackages.splice(index, 1)
          }
          if (orderPackage.status === 'ClientDoc') {
            this.clientDocPackages.splice(index, 1)
          }
          this.$emit('packageUpdated', new Date().getTime())

          this.addOrderNote(orderPackage.package.name + ' was deleted')
        })
    },
    loadPDF (orderPackage) {
      this.$emit('loadPDF', orderPackage.package.file)
    },
    uploadDocument (type) {
      var files = null
      var status = null
      if (type === 'dataEntry') {
        files = this.dataEntryFiles
        status = 'DataEntry'
      } else if (type === 'clientDoc') {
        files = this.clientDocFiles
        status = 'ClientDoc'
      } else {
        files = this.files
        status = 'RawDocs'
      }
      files.forEach((file, index) => {
        console.log(file, status)
        this.loading = true
        this.uploading = true
        var formData = new FormData()
        let filename = file.name.split('.')[0] + '-' + Date.now().toString() + '.' + file.name.split('.')[1]
        formData.append('name', filename)
        formData.append('file', file)
        this.$store.dispatch(UPLOADPACKAGE, formData).then(response => {
          let payload = {
            status: status,
            data_entry: false,
            client_doc: false,
            order: this.order.id,
            package: response.id
          }
          this.$store.dispatch(ADDORDERPACKAGE, payload).then(resp => {
            this.loading = false
            this.uploading = false
            resp.package = response
            if (type === 'dataEntry') {
              this.dataEntryPackages.push(resp)
              this.dataEntryFiles = undefined
            } else if (type === 'dataEntry') {
              this.clientDocPackages.push(resp)
              this.clientDocFiles = undefined
            } else {
              this.packages.push(resp)
              this.files = undefined
            }
            this.$emit('packageUpdated', new Date().getTime())
          }).catch(({ response }) => {
            this.loading = false
            this.uploading = false
          })
        }).catch(({ response }) => {
          this.loading = false
          this.uploading = false
        })
        this.addOrderNote(filename + ' was added')
      })
    },
    saveUnSortedPackages () {
      console.log(this.unSortedPackages)
      this.unSortedPackages.forEach((pkg, index) => {
        console.log(pkg, index)
        let ordPlg = pkg
        ordPlg.status = 'Sorted'
        if (pkg.package.category !== null) {
          this.loading = true
          this.snloading = true
          let packagePayload = {
            id: pkg.package.id,
            category: pkg.package.category.id
          }
          this.$store.dispatch(PATCHPACKAGE, packagePayload).then(resp => {
            console.log(resp)
            this.$emit('packageUpdated', new Date().getTime())
          })
          let orderPackagePayload = {
            id: pkg.id,
            status: 'Sorted',
            ordering: index + 1
          }
          this.$store.dispatch(PATCHORDERPACKAGE, orderPackagePayload).then(resp => {
            console.log(resp)
            this.sortedPackages.push(ordPlg)
            this.unSortedPackages.splice(index, 1)
            this.loading = false
            this.snloading = false
          }).catch(({ response }) => {
            this.loading = false
            this.snloading = false
            console.log(response)
          })
          this.addOrderNote(pkg.package.name + ' was sorted')
        }
      })
    },
    sortAllOrderPackages () {
      this.aloading = true
      let payload = {
        id: this.order.id
      }
      this.$store
        .dispatch(SORTALLORDERPACKAGES, payload)
        .then(() => {
          this.aloading = false
        })
    },
    approveSortedPackages () {
      this.loading = true
      this.asploading = true
      let lflag = false
      this.packages.forEach((pkg, index) => {
        console.log(this.packageChecks[index])
        let ordPlg = pkg
        ordPlg.status = 'Approved'
        if (this.packageChecks[index] === true) {
          let alreadyApproved = false
          this.approvedPackages.forEach((apkg, idx) => {
            if (apkg.id === pkg.id) {
              alreadyApproved = true
            }
          })
          if (alreadyApproved === false) {
            lflag = true
            let packagePayload = {
              id: pkg.package.id,
              category: pkg.package.category.id
            }
            this.$store.dispatch(PATCHPACKAGE, packagePayload).then(resp => {
              console.log(resp)
            })
            let orderPackagePayload = {
              id: pkg.id,
              status: 'Approved'
            }
            this.$store.dispatch(PATCHORDERPACKAGE, orderPackagePayload).then(resp => {
              console.log(resp)
              this.approvedPackages.push(ordPlg)
              this.rejectedPackages.forEach((rpkg, idxs) => {
                if (ordPlg.id === rpkg.id) {
                  this.rejectedPackages.splice(idxs, 1)
                }
              })
              this.$emit('packageUpdated', new Date().getTime())
              this.loading = false
              this.asploading = false
            }).catch(({ response }) => {
              console.log(response)
              this.loading = false
              this.asploading = false
            })
          }
          this.packageChecks[index] = false
          console.log(this.packageChecks[index])
          this.addOrderNote(pkg.package.name + ' was approved')
        }
      })
      if (lflag === false) {
        setTimeout(() => {
          this.loading = false
          this.asploading = false
        }, 600)
      }
    },
    rejectSortedPackages () {
      console.log(this.packages)
      this.packages.forEach((pkg, index) => {
        console.log(pkg, index, this.packageChecks[index])
        let ordPlg = pkg
        ordPlg.status = 'Rejected'
        if (this.packageChecks[index] === true) {
          let orderPackagePayload = {
            id: pkg.id,
            status: 'Rejected'
          }
          this.$store.dispatch(PATCHORDERPACKAGE, orderPackagePayload).then(resp => {
            console.log(resp)
            this.rejectedPackages.push(ordPlg)
          }).catch(({ response }) => {
            console.log(response)
          })
          this.addOrderNote(pkg.package.name + ' was rejected')
        }
      })
    },
    saveSortedPackages () {
      console.log(this.sortedPackages)
      this.loading = true
      this.ssploading = true
      let lflag = false
      this.sortedPackages.forEach((pkg, index) => {
        console.log(pkg, index, this.sortedChecks[index])
        if (this.sortedChecks[index] === true) {
          lflag = true
          let packagePayload = {
            id: pkg.package.id,
            category: pkg.package.category.id
          }
          this.$store.dispatch(PATCHPACKAGE, packagePayload).then(resp => {
            console.log(resp)
            this.$emit('packageUpdated', new Date().getTime())
            this.loading = false
            this.ssploading = false
          }).catch(({ response }) => {
            this.loading = false
            this.ssploading = false
          })
          this.addOrderNote(pkg.package.name + ' was updated')
        }
      })
      if (lflag === false) {
        setTimeout(() => {
          this.loading = false
          this.ssploading = false
        }, 600)
      }
    },
    saveApprovedPackages () {
      console.log(this.approvedPackages)
      this.loading = true
      this.saploading = true
      let lflag = false
      let packCount = 0
      this.approvedPackages.forEach((pkg, index) => {
        console.log(pkg, index, this.approvedPackages[index])
        if (this.approvedChecks[index] === true) {
          this.loading = true
          this.saploading = true
          lflag = true
          let packagePayload = {
            id: pkg.package.id,
            category: pkg.package.category.id
          }
          this.$store.dispatch(PATCHPACKAGE, packagePayload).then(resp => {
            console.log(resp)
            this.$emit('packageUpdated', new Date().getTime())
          }).catch(({ response }) => {
            this.loading = false
            this.saploading = false
          })
          this.addOrderNote(pkg.package.name + ' was saved')
        }
        let orderPackagePayload = {
          id: pkg.id,
          ordering: index + 1
        }
        this.$store.dispatch(PATCHORDERPACKAGE, orderPackagePayload).then(resp => {
          console.log(resp)
          this.loading = false
          this.saploading = false
        }).catch(({ response }) => {
          packCount = packCount + 1
          if (packCount === this.approvedPackages.length) {
            this.sortAllOrderPackages()
          }
          this.loading = false
          this.saploading = false
        })
      })
      if (lflag === false) {
        setTimeout(() => {
          this.loading = false
          this.saploading = false
        }, 600)
      }
    },
    saveRejectedPackages () {
      console.log(this.rejectedPackages)
      this.loading = true
      this.srploading = true
      let lflag = false
      this.rejectedPackages.forEach((pkg, index) => {
        console.log(pkg, index, this.rejectedPackages[index])
        if (this.rejectedChecks[index] === true) {
          this.loading = true
          this.srploading = true
          lflag = true
          let packagePayload = {
            id: pkg.package.id,
            category: pkg.package.category.id
          }
          this.$store.dispatch(PATCHPACKAGE, packagePayload).then(resp => {
            console.log(resp)
            this.$emit('packageUpdated', new Date().getTime())
            this.loading = false
            this.srploading = false
          }).catch(({ response }) => {
            this.loading = false
            this.srploading = false
          })
          this.addOrderNote(pkg.package.name + ' was saved')
        }
      })
      if (lflag === false) {
        setTimeout(() => {
          this.loading = false
          this.srploading = false
        }, 600)
      }
    },
    rejectApprovedPackages () {
      console.log(this.approvedPackages)
      this.approvedPackages.forEach((pkg, index) => {
        console.log(pkg, index, this.approvedChecks[index])
        let ordPlg = pkg
        ordPlg.status = 'Rejected'
        if (this.approvedChecks[index] === true) {
          this.loading = true
          this.raploading = true
          let orderPackagePayload = {
            id: pkg.id,
            status: 'Rejected'
          }
          this.$store.dispatch(PATCHORDERPACKAGE, orderPackagePayload).then(resp => {
            console.log(resp)
            this.rejectedPackages.push(ordPlg)
            this.approvedPackages.splice(index, 1)
            this.loading = false
            this.raploading = false
          }).catch(({ response }) => {
            console.log(response)
            this.loading = false
            this.raploading = false
          })
          this.addOrderNote(pkg.package.name + ' was rejected')
        }
      })
    },
    approveRejectedPackages () {
      console.log(this.rejectedPackages)
      this.loading = true
      this.arploading = true
      let lflag = false
      this.rejectedPackages.forEach((pkg, index) => {
        console.log(pkg, index, this.rejectedChecks[index])
        let ordPlg = pkg
        ordPlg.status = 'Approved'
        if (this.rejectedChecks[index] === true) {
          this.loading = true
          this.arploading = true
          lflag = true
          let orderPackagePayload = {
            id: pkg.id,
            status: 'Approved'
          }
          this.$store.dispatch(PATCHORDERPACKAGE, orderPackagePayload).then(resp => {
            console.log(resp)
            this.approvedPackages.push(ordPlg)
            this.rejectedPackages.splice(index, 1)
            this.loading = false
            this.arploading = false
          }).catch(({ response }) => {
            console.log(response)
            this.loading = false
            this.arploading = false
          })
          this.addOrderNote(pkg.package.name + ' was approved')
        }
      })
      if (lflag === false) {
        setTimeout(() => {
          this.loading = false
          this.arploading = false
        }, 600)
      }
    },
    addOrderNote (message) {
      let noteCreatedBy = JSON.parse(window.localStorage.getItem('auth')).user_data
      message = message + ' by ' + noteCreatedBy.username
      let assignerNotePayload = {
        note: message,
        order: this.order.id,
        type: 'Order'
      }
      console.log(POSTNOTE)
      console.log(assignerNotePayload)
      this.$store.dispatch(POSTNOTE, assignerNotePayload).then(noteResponse => {
        console.log(noteResponse)
      })
    },
    toggledocs () {
      let celem = this.packageChecks
      this.packageChecks = []
      for (let j = 0; j < celem.length; j++) {
        this.packageChecks.push(this.selectall)
      }
    }
  }
}
</script>

<style>

body {
  font-family: "Helvetica Neue",Helvetica,Arial,sans-serif;
  font-size: 14px;
  line-height: 1.428571429;
  color: #333;
  background-color: #e7edf0;
}
.order-data-table {
  height: 100vh;
  position: fixed;
  bottom: 0;
  width: 100%;
  margin: auto
}
.v-data-table td {
  font-size: 10px;
  font-weight: bold;
}
.v-chip__content {
  font-size: 10px;
  font-weight: bold;
}
.v-data-table td, .v-data-table th {
  padding: 0 5px;
}

.statusTab {
    color: #fff !important;
    background-color: #00abab !important;
    border-color: #00abab;
    width: 120px;
    height: 50px !important;
    display: table-cell;
    vertical-align: middle;
    margin-right: 40px;
    font-size: 10px !important;
    font-weight: 900;
}

.activeStatusTab {
    background-color: #4e6692 !important;
    border-color: #4e6692 !important;
    color: #fff !important;
    width: 120px;
    height: 50px !important;
    display: table-cell;
    vertical-align: middle;
    margin-right: 40px;
    font-size: 10px !important;
    font-weight: 900;
}

.statusTabLine {
  width: 100%;
}

.statusTabLine:before {
    width: 85%;
    background: #d9544f;
    content: "";
    height: 1px;
    position: relative!important;
    padding: 2px;
    top: 40px!important;
    left: 0!important;
    margin: auto;
    display: inline-block;
}

.orderContainer {
  width: 90%;
  margin: auto;
  background-color: white;
  min-height: 800px;
}

.orderHeader {
  width: 90%;
  margin: auto;
  padding: 0px;
  border-bottom: none;
  font-family: 'Open Sans', sans-serif;
  font-size: 24px;
  font-weight: 600;
  padding-top: 10px;
  padding-bottom: 10px;
}

.firstPan > .v-toolbar__content {
    height: 0px !important;
}
.v-sheet--tile {
    height: 60px !important;
}

.v-tab {
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-flex: 0;
  -ms-flex: 0 1 auto;
  flex: 0 1 auto;
  font-size: .875rem;
  font-weight: 500;
  -webkit-box-pack: center;
  -ms-flex-pack: center;
  justify-content: center;
  letter-spacing: .0892857143em;
  line-height: normal;
  min-width: 90px;
  max-width: 360px;
  outline: none;
  padding: 0 16px;
  position: relative;
  text-align: center;
  text-decoration: none;
  text-transform: uppercase;
  -webkit-transition: none;
  transition: none;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
  background-color: white !important;
  color: black !important;
  font-size: 13px;
}
.v-input--selection-controls__ripple{
  z-index:100;
}
.theme--dark.v-btn.v-btn--disabled:not(.v-btn--flat):not(.v-btn--text):not(.v-btn--outlined) {
  background-color: rgba(0,0,0,.12)!important;
  color: rgba(0,0,0,.42) !important;
}
.btn-wrapper{
  display: inline-block;
}
.disableClass{
  pointer-events: auto !important;
}
.rawckall {
  margin-top: 0px !important;
  display: inline-flex;
  width: 25px;
  height:42px !important;
}
</style>
